import classNames from "classnames";
import curtain from "./curtain.svg";
import romanBlind from "./roman-blind.svg";
import styles from "./M2MProductSelector.module.scss";

export type M2MProductButtonProps = {
  productUrl: string;
  isRoman: boolean;
};

export function M2MProductButton({
  productUrl,
  isRoman,
}: M2MProductButtonProps) {
  const imageToUse = isRoman ? romanBlind : curtain;

  const buildText = () => (isRoman ? "Roman Blind" : "Curtain");

  const buildAltText = () => (isRoman ? "Roman Blind Image" : "Curtain Image");

  const buildClassName = () => (isRoman ? "rightButton" : "leftButton");

  return (
    <a
      className={classNames(styles.productLink)}
      href={productUrl}
      data-testid={`product-selector-${buildText()
        .toLowerCase()
        .replace(" ", "-")}`}
    >
      <figure className={classNames(styles.button, styles[buildClassName()])}>
        <img src={imageToUse} alt={buildAltText()} aria-hidden="true" />
        <figcaption className={styles.caption}>{buildText()}</figcaption>
      </figure>
    </a>
  );
}
